import type { WaterfallView } from 'api/models/WaterfallView';
import { WaterfallViewsService } from 'api/services/WaterfallViewsService';

export type { WaterfallView };

export type CreateWaterfallViewPayload = Omit<WaterfallView, 'id' | 'created_at' | 'updated_at' | 'measurement_date_value'>;
export type UpdateWaterfallViewPayload = Partial<Omit<CreateWaterfallViewPayload, 'company'>>;

export const waterfallViewsApi = {
  list: (companyId?: number, measurementDateId: number | null = null): Promise<WaterfallView[]> =>
    WaterfallViewsService.apiWaterfallViewsList(measurementDateId ?? 0, companyId),

  create: (payload: CreateWaterfallViewPayload): Promise<WaterfallView> =>
    WaterfallViewsService.apiWaterfallViewsCreate(payload),

  update: (id: number, payload: UpdateWaterfallViewPayload): Promise<WaterfallView> =>
    WaterfallViewsService.apiWaterfallViewsPartialUpdate(String(id), payload as WaterfallView),

  delete: (id: number): Promise<void> =>
    WaterfallViewsService.apiWaterfallViewsDelete(String(id)),
};
